import CollapseCategories16 from '@carbon/icons-react/es/collapse-categories/16';
import ExpandCategories16 from '@carbon/icons-react/es/expand-categories/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import { RadioGroup } from 'components/atoms/radio-buttons';
import { FilterBar } from 'components/molecules/filter-bar';
import { ProjectTemplateSpaceData } from 'data/templates/projects';
import { useTranslation } from 'hooks/use-translation';
import { ViewGroup } from './view-group';

const TopBar = styled(FilterBar)`
  position: sticky;
  top: 0;
  left: 0;
`;

const StyledFilterBar = styled(FilterBar.Primary)`
  width: 375px;
  flex: none !important;

  > :first-child {
    /* margin-left: var(--spacing-03) !important; */
    flex-grow: 1;
  }
`;

const StyledRadioGroup = styled(RadioGroup)`
  grid-template-columns: repeat(1, minmax(0, 1fr));

  .ant-radio-button-wrapper {
    svg {
      margin-right: 0;
    }
  }
`;

export const ProjectSpacesTemplateToolBar: FC<{
  data?: ProjectTemplateSpaceData[];
  mode?: string | null;
  expandCollapse?: (e) => void;
}> = ({ data, mode, expandCollapse }) => {
  const expandAllTooltipText = useTranslation('expand_all_tasks');
  const collapseAllTooltipText = useTranslation('collapse_all_tasks');

  const { pathname } = useLocation();

  const isDynamic = pathname.includes('dynamic');

  return (
    <TopBar>
      <StyledFilterBar>
        <ViewGroup />
        {isDynamic && (
          <StyledRadioGroup
            disabled={data?.length === 0}
            value={mode}
            onChange={expandCollapse}
          >
            {mode === 'expand' ? (
              <Radio.Button value="collapse">
                <Tooltip title={collapseAllTooltipText}>
                  <CollapseCategories16 />
                </Tooltip>
              </Radio.Button>
            ) : (
              <Radio.Button value="expand">
                <Tooltip title={expandAllTooltipText}>
                  <ExpandCategories16 />
                </Tooltip>
              </Radio.Button>
            )}
          </StyledRadioGroup>
        )}
      </StyledFilterBar>
    </TopBar>
  );
};
